"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function () {}; return { s: F, n: function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (e) { throw e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function () { it = it.call(o); }, n: function () { var step = it.next(); normalCompletion = step.done; return step; }, e: function (e) { didErr = true; err = e; }, f: function () { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        let key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: () => from[key],
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: true
}), mod);
var handlers_exports = {};
__export(handlers_exports, {
  RealtimeSocketHandler: () => RealtimeSocketHandler,
  defaultLanguage: () => defaultLanguage
});
module.exports = __toCommonJS(handlers_exports);
var import_types = require("../types");
const defaultLanguage = "en";
const rtDefaultConfig = {
  language: defaultLanguage
};
const defaultAudioFormat = {
  type: "file"
};
class RealtimeSocketHandler {
  constructor(sub, socketWrapImplementation) {
    this.seqNoIn = 0;
    this.onSocketMessage = data => {
      var _this$sub, _this$sub$onRecogniti, _this$startRecognitio, _this$sub2, _this$sub2$onWarning, _this$sub3, _this$sub3$onFullRece, _this$sub4, _this$sub4$onPartialR, _this$sub5, _this$sub5$onFullTran, _this$sub6, _this$sub6$onPartialT, _this$sub7, _this$sub7$onRecognit, _this$stopRecognition, _this$sub8, _this$sub8$onError, _this$rejectPromise, _this$sub9, _this$sub9$onInfo;
      switch (data.message) {
        case import_types.RealtimeMessageMessageEnum.RecognitionStarted:
          (_this$sub = this.sub) === null || _this$sub === void 0 ? void 0 : (_this$sub$onRecogniti = _this$sub.onRecognitionStart) === null || _this$sub$onRecogniti === void 0 ? void 0 : _this$sub$onRecogniti.call(_this$sub, data);
          (_this$startRecognitio = this.startRecognitionResolve) === null || _this$startRecognitio === void 0 ? void 0 : _this$startRecognitio.call(this, data);
          break;
        case import_types.RealtimeMessageMessageEnum.AudioAdded:
          this.seqNoIn = data.seq_no || 0;
          break;
        case import_types.RealtimeMessageMessageEnum.Warning:
          (_this$sub2 = this.sub) === null || _this$sub2 === void 0 ? void 0 : (_this$sub2$onWarning = _this$sub2.onWarning) === null || _this$sub2$onWarning === void 0 ? void 0 : _this$sub2$onWarning.call(_this$sub2, data);
          break;
        case import_types.RealtimeMessageMessageEnum.AddTranscript:
          this.seqNoIn++;
          (_this$sub3 = this.sub) === null || _this$sub3 === void 0 ? void 0 : (_this$sub3$onFullRece = _this$sub3.onFullReceived) === null || _this$sub3$onFullRece === void 0 ? void 0 : _this$sub3$onFullRece.call(_this$sub3, data);
          break;
        case import_types.RealtimeMessageMessageEnum.AddPartialTranscript:
          (_this$sub4 = this.sub) === null || _this$sub4 === void 0 ? void 0 : (_this$sub4$onPartialR = _this$sub4.onPartialReceived) === null || _this$sub4$onPartialR === void 0 ? void 0 : _this$sub4$onPartialR.call(_this$sub4, data);
          break;
        case import_types.RealtimeMessageMessageEnum.AddTranslation:
          this.seqNoIn++;
          (_this$sub5 = this.sub) === null || _this$sub5 === void 0 ? void 0 : (_this$sub5$onFullTran = _this$sub5.onFullTranslationReceived) === null || _this$sub5$onFullTran === void 0 ? void 0 : _this$sub5$onFullTran.call(_this$sub5, data);
          break;
        case import_types.RealtimeMessageMessageEnum.AddPartialTranslation:
          (_this$sub6 = this.sub) === null || _this$sub6 === void 0 ? void 0 : (_this$sub6$onPartialT = _this$sub6.onPartialTranslationReceived) === null || _this$sub6$onPartialT === void 0 ? void 0 : _this$sub6$onPartialT.call(_this$sub6, data);
          break;
        case import_types.RealtimeMessageMessageEnum.EndOfTranscript:
          (_this$sub7 = this.sub) === null || _this$sub7 === void 0 ? void 0 : (_this$sub7$onRecognit = _this$sub7.onRecognitionEnd) === null || _this$sub7$onRecognit === void 0 ? void 0 : _this$sub7$onRecognit.call(_this$sub7);
          (_this$stopRecognition = this.stopRecognitionResolve) === null || _this$stopRecognition === void 0 ? void 0 : _this$stopRecognition.call(this);
          break;
        case import_types.RealtimeMessageMessageEnum.Error:
          (_this$sub8 = this.sub) === null || _this$sub8 === void 0 ? void 0 : (_this$sub8$onError = _this$sub8.onError) === null || _this$sub8$onError === void 0 ? void 0 : _this$sub8$onError.call(_this$sub8, data);
          (_this$rejectPromise = this.rejectPromise) === null || _this$rejectPromise === void 0 ? void 0 : _this$rejectPromise.call(this, data);
          break;
        case import_types.RealtimeMessageMessageEnum.Info:
          (_this$sub9 = this.sub) === null || _this$sub9 === void 0 ? void 0 : (_this$sub9$onInfo = _this$sub9.onInfo) === null || _this$sub9$onInfo === void 0 ? void 0 : _this$sub9$onInfo.call(_this$sub9, data);
          break;
        default:
          throw new Error("Unexpected message");
      }
    };
    this.onSocketDisconnect = () => {
      var _this$sub$onDisconnec, _this$sub10;
      (_this$sub$onDisconnec = (_this$sub10 = this.sub).onDisconnect) === null || _this$sub$onDisconnec === void 0 ? void 0 : _this$sub$onDisconnec.call(_this$sub10);
    };
    this.onSocketError = error => {
      var _this$sub$onError, _this$sub11, _this$rejectPromise2;
      (_this$sub$onError = (_this$sub11 = this.sub).onError) === null || _this$sub$onError === void 0 ? void 0 : _this$sub$onError.call(_this$sub11, error);
      (_this$rejectPromise2 = this.rejectPromise) === null || _this$rejectPromise2 === void 0 ? void 0 : _this$rejectPromise2.call(this, error);
    };
    this.sub = sub;
    this.socketWrap = socketWrapImplementation;
    this.socketWrap.onMessage = this.onSocketMessage;
    this.socketWrap.onError = this.onSocketError;
    this.socketWrap.onDisconnect = this.onSocketDisconnect;
  }
  async connect(runtimeURL, runtimeKey, appId) {
    this.seqNoIn = 0;
    return this.socketWrap.connect(runtimeURL, runtimeKey, appId);
  }
  async disconnect() {
    return this.socketWrap.disconnect();
  }
  isConnected() {
    return this.socketWrap.isOpen();
  }
  sendAudioBuffer(data) {
    this.socketWrap.sendAudioBuffer(data);
  }
  async startRecognition(config) {
    const startRecognitionMessage = {
      transcription_config: (config === null || config === void 0 ? void 0 : config.transcription_config) || rtDefaultConfig,
      audio_format: (config === null || config === void 0 ? void 0 : config.audio_format) || defaultAudioFormat,
      translation_config: config === null || config === void 0 ? void 0 : config.translation_config,
      message: "StartRecognition"
    };
    this.socketWrap.sendMessage(JSON.stringify(startRecognitionMessage));
    this.seqNoIn = 0;
    return new Promise((resolve, reject) => {
      this.startRecognitionResolve = resolve;
      this.rejectPromise = reject;
    });
  }
  async stopRecognition() {
    if (!this.socketWrap.isOpen()) {
      return;
    }
    const stopMessage = JSON.stringify({
      message: import_types.RealtimeMessageMessageEnum.EndOfStream,
      last_seq_no: this.seqNoIn
    });
    this.socketWrap.sendMessage(stopMessage);
    return new Promise((resolve, reject) => {
      this.stopRecognitionResolve = resolve;
      this.rejectPromise = reject;
    }).then(() => {
      return this.socketWrap.disconnect();
    });
  }
}